import { createApplicationData } from 'core-components/sitebuilder/models/IApplication'
import { createUser } from 'core-components/sitebuilder/models/IUser'
import { ISiteBuilderState } from 'core-components/sitebuilder/store/models/ISiteBuilderState'
import { createWidgetData } from 'core-components/sitebuilder/store/models/IWidgetData'

export const initialState: ISiteBuilderState = {
  app: createApplicationData(),
  currentSitePageId: null,
  calledFlexWrapperAction: undefined,
  editLayoutMode: false,
  flexSettings: { items: [], version: '0' },
  flexActions: {},
  sitePagesLoaded: false,
  sitePages: [],
  sitePagesSettings: [],
  user: createUser(),
  widgets: [],
  routeParams: {},
  roles: [],
  widgetData: createWidgetData(),
}
